module.exports = {"513331100":"建设镇","513331101":"阿察镇","513331200":"金沙乡","513331201":"绒盖乡","513331202":"章都乡","513331203":"麻绒乡","513331204":"河坡乡","513331205":"热加乡","513331206":"登龙乡","513331207":"赠科乡","513331209":"麻邛乡","513331210":"辽西乡","513331211":"纳塔乡","513331212":"安孜乡","513331213":"盖玉乡","513331214":"沙马乡","513331215":"山岩乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/513331.json
// module id = 2422
// module chunks = 0